import { render, staticRenderFns } from "./StaffNavbar.vue?vue&type=template&id=8834a65e"
import script from "./StaffNavbar.vue?vue&type=script&lang=js"
export * from "./StaffNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports